import { StatisticPage } from "@/features/statistic/statistic-page";

export default StatisticPage;
